import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { waitForTrackingReady } from '@brightside-web/desktop/data-access/shared';
import { BsAuthService } from './bs-auth.service';

export const ssoLoginGuard = () => {
  const bsAuthService = inject(BsAuthService);
  const params = new URLSearchParams(window.location.search);
  const source = params.get('source');
  void (async () => {
    await waitForTrackingReady();
    bsAuthService.loginWithSso(source || '');
  })();
  return true;
};

export const auth0LoginGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const bsAuthService = inject(BsAuthService);
  const router = inject(Router);
  const loginType = route.params['loginType'];
  if (loginType === 'login') {
    bsAuthService.login();
    return true;
  }
  if (loginType === 'signup') {
    bsAuthService.login('signup');
    return true;
  }
  router.navigate(['/']);
  return false;
};
